import React from "react";
import { Box, Typography } from "@material-ui/core";
import { Check, Close } from "@material-ui/icons";

export const SettingItem = ({ label, value }) => (
  <Box style={{ display: "inline-flex", alignItems: "center", width: 120, height: 20 }}>
    {value ? (
      <Check style={{ fontSize: 14, color: "#4caf50", marginRight: 4 }} data-testid="check-icon"/>
    ) : (
        <Close style={{ fontSize: 14, color: "#bdbdbd", marginRight: 4 }} data-testid="close-icon" />
    )}
    <Typography variant="body2" style={{ color: "#666", fontSize: 13 }}>
      {label}
    </Typography>
  </Box>
)